/**
 * @generated SignedSource<<e05486b7a585969bd1ad65a4fca22c32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MultiSlotSidebarSessionFragment_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "MultiSlotSidebarSessionFragment_session";
};
export type MultiSlotSidebarSessionFragment_session$key = {
  readonly " $data"?: MultiSlotSidebarSessionFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultiSlotSidebarSessionFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MultiSlotSidebarSessionFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "87f9b85c4d8d7fab108f82f2579ca5de";

export default node;
